// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"VideoPlayer_icomoon-font__3LozQ","GalleryPlayButton":"VideoPlayer_GalleryPlayButton__1Fpgz","CmsVideoPlayButton":"VideoPlayer_CmsVideoPlayButton__Jho-X"};